export const DEVICE_TYPE = {
  WINDOWS: "Windows",
  MACOS: "Macintosh",
  MACOSM: "macOS",
  MACOSX: "Mac OS",
  IOS: "iOS",
  IPAD: "iPad",
  IPHONE: "iPhone",
  IPOD: "iPod",
  ANDROID: "Android",
  WEB: "Web",
};

export const ANDROID_DEVICES = [
    DEVICE_TYPE.ANDROID
]

export const APPLE_DEVICES = [
  DEVICE_TYPE.MACOS,
  DEVICE_TYPE.MACOSM,
  DEVICE_TYPE.MACOSX,
  DEVICE_TYPE.IOS,
  DEVICE_TYPE.IPAD,
  DEVICE_TYPE.IPHONE,
  DEVICE_TYPE.IPOD,
];

export const BROWSERS = {
  CHROME: "Chrome",
  FIREFOX: "Firefox",
  SAFARI: "Safari",
  EDGE: "Edge",
  SAMSUNG: "Samsung Internet",
};

export const BROWSER_MOBILE = {
  MOBILE_SAFARI: "Mobile Safari",
  MOBILE_CHROME: "Mobile Chrome",
  MOBILE_FIREFOX: "Mobile Firefox",
  MOBILE_EDGE: "Mobile Edge",
};

// Constantes para WebViews
export const WEBVIEW_TYPES = {
  IOS_WEBVIEW: "iOS-WebView",
  ANDROID_WEBVIEW: "Android-WebView",
  GENERIC_WEBVIEW: "WebView",
};
